import { ReleaseHighlight } from "@/entities/release-highlight";
import { Badge } from "@/shared/components";

/** Toont of een bericht al zichtbaar is voor de andere rollen of nog in de wacht staat. */
export function PublicatieStatusBadge({ bericht }: Readonly<{ bericht: ReleaseHighlight }>) {
    const isGepubliceerd = ReleaseHighlight.isPublished(bericht);

    return (
        <Badge variant={isGepubliceerd ? "green-subtle" : "yellow-subtle"} size="m" data-testid="release-highlight-status">
            {isGepubliceerd ? "Gepubliceerd" : "Gepland"}
        </Badge>
    );
}
